import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchCatalog = createAsyncThunk('catalogSlice/fetchCatalog', async () => {
    // eslint-disable-next-line no-undef
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?catalog`)
    const data = await res.json()
    return data;
})

const catalogSlice = createSlice({
    initialState: {
        catalog: [],
        loading: false,
        error: null,
        status: 'idle',
    },
    name: 'catalogSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchCatalog.pending, (state) => {
                state.loading = true;
                state.status = 'loading';
            })
            .addCase(fetchCatalog.fulfilled, (state, action) => {
                state.loading = false;
                state.catalog = action.payload;
                state.status = 'succeeded';
            })
            .addCase(fetchCatalog.rejected, (state, action) => {
                state.loading = false;
                state.status = 'failed';
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

// eslint-disable-next-line no-empty-pattern
export const { } = catalogSlice.actions;

export default catalogSlice.reducer;